import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueClipboard from 'vue-clipboard2'
import VueParticles from 'vue-particles'
 import animate from 'animate.css';

Vue.config.productionTip = false
Vue.use(VueClipboard)
Vue.use(VueParticles)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
